import React, { Suspense, lazy } from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../_metronic/layout";
import { BuilderPage } from "./pages/BuilderPage";
import { DashboardPage } from "./pages/DashboardPage";
import { CustomersPage } from "././modules/ECommerce/pages/customers/CustomersPage";
import { AccountSettingsPage } from "././modules/ECommerce/pages/account-settings/AccountSettingsPage";
import { ProductsPage } from "././modules/ECommerce/pages/products/ProductsPage";
import { UserChildsPage } from "././modules/SystemUser/pages/UserChilds";
import { UserChildsLoginPage } from "././modules/SystemUser/pages/UserChildsLoginPage";
import { UnassignedCustomers } from "././modules/SystemUser/pages/UnassignedCustomers";
import AdminDashboard from "./modules/SystemUser/pages/AdminDashboard/AdminDashboard";
import UnknownEmailSender from "./modules/SystemUser/pages/AdminDashboard/UnknownEmailSender";
import { UnmappedFileReroute } from "./modules/SystemUser/pages/AdminDashboard/UnmappedFileReroute";

const UserProfilepage = lazy(() =>
  import("./modules/UserProfile/UserProfilePage")
);

export default function BasePage() {
  // useEffect(() => {
  //   console.log('Base page');
  // }, []) // [] - is required if you need only one call
  // https://reactjs.org/docs/hooks-reference.html#useeffect

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {
          /* Redirect from root URL to /dashboard. */
          <Redirect exact from="/" to="/dashboard" />
        }
        <ContentRoute path="/dashboard" component={DashboardPage} />
        <ContentRoute path="/builder" component={BuilderPage} />

        <Route path="/user-profile" component={UserProfilepage} />

        <Route path="/customers" component={CustomersPage} />

        <Route
          path="/invoice/:guid/:userType/:fileUrl"
          component={UnmappedFileReroute}
        />

        <Route path="/invoice" component={ProductsPage} />
        <Route path="/account-settings" component={AccountSettingsPage} />
        <Route path="/user-childs" component={UserChildsPage} />
        <Route
          path="/user-child/:guid/:userType"
          component={UserChildsLoginPage}
        />

        <Route path="/unassigned-customers" component={UnassignedCustomers} />

        <Route path="/admin-dashboard" component={AdminDashboard} />
        <Route path="/unknown-email-senders" component={UnknownEmailSender} />

        <Redirect to="error/error-v1" />
      </Switch>
    </Suspense>
  );
}
